import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n'

import messages from '~/assets/lang'

Vue.use(Vuetify)
Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'ru', // set locale
  messages // set locale messages
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#007bdd'
      }
    }
  },
  icons: {
    iconfont: 'mdiSvg'
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
